import { makeStyles } from '@lifeomic/chroma-react/styles';
import Grid from '@mui/material/Grid';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
    justifyContent: 'center',
  },
  imageBoxImage: {
    alignSelf: 'center',
    maxWidth: '100%',
    verticalAlign: 'middle',
    border: `1px solid ${theme.palette.divider}`,
  },
}));

export const ImageBox = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  file,
}) => {
  const classes = useStyles({});
  return (
    <Grid container item xs={12} className={classes.root}>
      <img
        className={classes.imageBoxImage}
        src={file.downloadUrl}
        alt={file.name}
      />
    </Grid>
  );
};
